import { Loader2, ShieldCheck, Star, Megaphone, XCircle } from "lucide-react";

const addonIcons = {
  verification_basic: ShieldCheck,
  verification_premium: ShieldCheck,
  featured_listing: Star,
  sponsored_listing: Megaphone,
};

export default function AddonsGrid({ config, sub, busy, onBuy, onCancelAddon }) {
  const activeAddons = sub?.addon_subscriptions || [];
  const activeMap = Object.fromEntries(activeAddons.map((a) => [a.addon_id, a]));
  const hasActiveListing = activeAddons.length > 0;

  return (
    <div className="mt-6">
      <h3 className="font-heading text-lg font-bold text-[#0A0F1C] mb-1">Boost your presence</h3>
      <p className="text-sm text-slate-500 mb-3">
        Listing add-ons are monthly subscriptions and affect directory placement only — never your AI match quality, trust score or verification.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {config?.addons && Object.values(config.addons).map((a) => {
          const Icon = addonIcons[a.id] || Star;
          const isRecurring = a.type === "recurring_monthly";
          const active = activeMap[a.id];
          const blocked = isRecurring && hasActiveListing && !active;
          const canceling = active?.cancel_at_period_end;
          const endDate = active?.current_period_end
            ? new Date(active.current_period_end).toLocaleDateString() : null;

          return (
            <div key={a.id} className="rounded-xl border border-slate-200 bg-white p-5 flex flex-col" data-testid={`addon-${a.id}`}>
              <Icon size={20} className="text-[#C2410C]" />
              <h4 className="mt-3 font-medium text-[#0A0F1C]">
                {a.name}
                {a.id === "sponsored_listing" && (
                  <span className="ml-1.5 text-[10px] font-semibold uppercase tracking-wide text-[#6D28D9] bg-[#6D28D9]/10 px-1.5 py-0.5 rounded">Ad</span>
                )}
              </h4>
              <p className="mt-1 font-mono text-xl font-bold text-[#0A0F1C]">
                ${a.amount}
                <span className="text-xs font-normal text-slate-400">{isRecurring ? "/mo" : " once"}</span>
              </p>

              {active ? (
                <div className="mt-4 flex flex-col gap-2">
                  <span data-testid={`addon-active-${a.id}`}
                    className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full bg-green-100 text-green-700 self-start">
                    {canceling ? "Ending" : "Active"}
                  </span>
                  {canceling && endDate ? (
                    <p className="text-xs text-slate-500">Placement ends {endDate}</p>
                  ) : (
                    <button onClick={() => onCancelAddon(a.id)} disabled={busy === `cancel-${a.id}`}
                      data-testid={`addon-cancel-${a.id}`}
                      className="h-9 rounded-md border border-red-200 text-red-600 text-sm font-medium flex items-center justify-center gap-1.5 hover:bg-red-50 transition-colors disabled:opacity-60">
                      {busy === `cancel-${a.id}` ? <Loader2 className="animate-spin" size={15} /> : <><XCircle size={14} /> Cancel</>}
                    </button>
                  )}
                </div>
              ) : (
                <>
                  <button onClick={() => onBuy(a.id)} disabled={busy === a.id || blocked}
                    data-testid={`addon-buy-${a.id}`}
                    className="mt-4 h-9 rounded-md bg-[#0A0F1C] text-white text-sm font-medium flex items-center justify-center gap-1.5 hover:bg-[#1E293B] transition-colors disabled:opacity-60">
                    {busy === a.id ? <Loader2 className="animate-spin" size={15} /> : (isRecurring ? "Subscribe" : "Purchase")}
                  </button>
                  {blocked && (
                    <p className="mt-1.5 text-[11px] text-slate-400">Cancel your current listing add-on first.</p>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
